import { CForm, CFormInput} from "@coreui/react";
import { ChangeEvent, useState } from "react";
import { t } from 'i18next';
import { useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { CardTextModel } from "@models/card-text.model";
import { useNavigate } from 'react-router';
import { useSpinner } from '@webkit/components/typescript/SpinnerContext';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import cardTextService from "@services/cardText.service";
import { getToastStore } from "@utils/ToastStore";
import { errorToast, handleDefaultImgClick, successToast } from "@webkit/functions/utils";
import ImageCarousel from "@webkit/components/typescript/DefaultImagesCarousel";

export default function CardTextPage() {
    const ctxToast = getToastStore();
    const location = useLocation();
    const [description, setDescription] = useState('');
    
    const { showSpinner, hideSpinner } = useSpinner();
    const navigate = useNavigate();
    //campi per caricamento immagine e preview
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const formData = new FormData();
    const isDisabled = (!description);

    const handleSubmit = async () => {
        try {
            showSpinner();
            if (selectedFile) {
                formData.append('img', selectedFile);
            }
            const segments = location.pathname.split('/').filter(Boolean);
            const IdAccomodation = segments.at(1) ?? '';
            const IdParent = segments.at(2) ?? '';
            const cardTextModel = new CardTextModel(description, IdParent);
            await cardTextService.createCardText(IdAccomodation, cardTextModel, formData);
            successToast(ctxToast, t("success.updated"));
            navigate(`/new-app/${IdAccomodation}`);
        } catch (error: any) {
            console.error('errore nella chiamata di creazione card Text', error);
        } finally {
            hideSpinner();
        }

    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]
        const maxSize = 5 * 1024 * 1024;
        if (file) {
            if (file.type !== "image/jpeg" && file.type !== "image/png" && file.type !== "image/jpg") {
                errorToast(ctxToast, t("error.invalid_image_format"));
                e.target.value = "";
                return;
            }
            if (file.size > maxSize) {
                errorToast(ctxToast, t("error.too_large"));
                e.target.value = "";
                return;
            }
            setSelectedFile(file)
            // crea un’anteprima temporanea
            const previewUrl = URL.createObjectURL(file)
            setPreview(previewUrl)
            formData.append('img', file);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className="card shadow-lg" style={{ width: '70%', borderRadius: '25px' }}>
                <div className="hst-card-header card-header text-uppercase">
                    {t('title.create_cardtext')}
                </div>
                <div className="card-body">
                    <CForm className="mb-5">
                        <label className="mb-3">{t('label.description')} {t('placeholder.obligatory')}</label>
                        <ReactQuill
                            theme="snow"
                            value={description}
                            onChange={(e) => {
                                if (e == '' || e == '<p><br></p>') {
                                    setDescription('')
                                } else {
                                    setDescription(e);
                                }

                            }}
                            style={{ borderRadius: "15px", height: "300px", marginBottom: "75px" }}
                        />
                        <p className="my-4">{t('text.default_images')}</p>
                        <ImageCarousel 
                            onImageSelect={(base64, index) => 
                            handleDefaultImgClick(base64, index, setSelectedFile, setPreview, formData)
                        }/>
                        <CFormInput
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                        {preview && (
                            <div className="preview-card position-relative">
                                <img
                                    src={preview}
                                    alt={t('label.preview')}
                                    style={{ maxWidth: '200px', height: 'auto' }}
                                />
                                <button
                                    className="hst-close-button-box"
                                    type="button"
                                    onClick={(e) =>{ 
                                        setSelectedFile(null)
                                        setPreview(null)
                                    }}
                                >
                                    ✕
                                </button>
                            </div>
                        )}
                    </CForm>
                    <div
                        className="card-footer bg-transparent w-100"
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: "20px" }}
                    >
                        <Button
                            className="hst-btn-secondary"
                            onClick={() => navigate(-1)}
                        >
                            {t('text.go_back')}
                        </Button>

                        <Button
                            className="text-uppercase hst-btn-primary"
                            onClick={() => handleSubmit()}
                            disabled={isDisabled}
                            style={{fontWeight:"500"}}
                        >
                            {t('button.save')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
};